import {
  Button,
  Form,
  Input,
  Modal,
  Popconfirm,
  DatePicker,
  Select,
  Card,
  Alert,
  Tag,
} from "antd";
import React, { useEffect, useState } from "react";
import dayjs from 'dayjs';
import { Link } from "react-router-dom";

import { recordError } from "../../../utils/logService";
import commonLookupService from "../../../services/commonLookupService";
import financialYearService from "../../../services/finYearService";
import nysProgrammeService from "../../../services/nysProgrammeService";
import DynamicField from "./DynamicField";

import {
  Messages,
  Notify,
  openNotification,
  util
} from '@seims/shared';

const config = {
  rules: [
    {
      type: "object",
      required: true,
      message: "Please select start date!",
    },
  ],
};
const config1 = {
  rules: [
    {
      type: "object",
      required: true,
      message: "Please select end date!",
    },
  ],
};

export default function AddNYSProgramme(props) {
  const [disabled, setDisabled] = useState(true);
  const [titles, setTitles] = useState([]);
  const [finYears, setFinYears] = useState([]);
  const [activeFinYear, setActiveFinYear] = useState([]);
  const [defaultFinYear, setDefaultFinYear] = useState({});
  const [disableForm, setDisableForm] = useState(false);
  const [selectedFinYear, setSelectedFinYear] = useState({});

  useEffect(() => {
    loadTitles();
    loadFinancialYears();
    loadActiveFinancialYear();
  }, [props.record]);

  let msg = "";

  const [form] = Form.useForm();
  const { Option } = Select;
  const formName = "AddNYSProgramme";

  const Confirm = () => {
    form.resetFields([
      "name",
      "description",
      "date-picker",
      "date-picker1",
      "contactName",
      "contactNumbers",
      "surname",
      "title_id",
      "email",
    ]);
    props.onShow(false);
    setDisabled(true);
  };

  const onChange = (selected) => {
    const selectedFinYear = finYears.find(
      (record) => record.value === selected
    );
    setSelectedFinYear(selectedFinYear);

    form.setFieldsValue({ financialYear: selectedFinYear });

    getProgrammeByFinYear(selectedFinYear.endDate);
  };

  const handleCancel = () => {
    if (
      form.getFieldValue("name") ||
      form.getFieldValue("description") ||
      form.getFieldValue("financialYear") ||
      form.getFieldValue("startDate") ||
      form.getFieldValue("endDate")
    ) {
      setDisabled(false);
    } else {
      form.resetFields();
      props.onShow(false);
      setDisabled(true);
    }
  };

  const loadTitles = async () => {
    try {
      const response = await commonLookupService.getTitles();
      if (response) {
        const { data } = response;

        setTitles(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const loadFinancialYears = async () => {
    try {
      const response = await financialYearService.getAllFinYears();
      if (response) {
        const { data } = response;
        // const sortData = data?.sort(util.setDynamicSort("value"));
        setFinYears(data);
      }
    } catch (error) {
      recordError(error);
    }
  };
  const getProgrammeByFinYear = async (selectedEndDate) => {
    try {
      const response = await nysProgrammeService.getProgrammeByFinYear(
        selectedEndDate
      );
      if (response?.status === 200) {
        let msg = util.parseMessage(
          "Programme already exist for the selected Financial Year",
          "NYS Programme"
        );
        openNotification("Create Programme", msg, Notify.ERROR);
        setDisableForm(true);
      } else {
        setDisableForm(false);
      }
    } catch (error) {
      setDisableForm(false);

      const { status } = error.response;
      if (status !== 404) return recordError(error);
    }
  };

  const loadActiveFinancialYear = async () => {
    try {
      const response = await financialYearService.getActiveFinancialYear();

      if (response) {
        const { data } = response;

        form.setFieldsValue({
          financialYear: data.shortValue,
        });
        setActiveFinYear(data);
        setSelectedFinYear(data);
        setDisableForm(true);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const createProgramme = async (fieldsValue) => {
    const {
      name,
      description,
      financialYear,
      startDate,
      endDate,
      contactName,
      surname,
      title_id,
      email,
      contactNumbers,
    } = fieldsValue;

    const finYearData = finYears.find(
      (value) => value.shortValue === financialYear
    );

    let finYear = {};

    if (finYearData != null) {
      finYear = {
        id: finYearData.id,
        shortValue: finYearData.shortValue,
        value: finYearData.value,
        startDate: finYearData.startDate,
        endDate: finYearData.endDate,
      };
    }

    const nysProgrammeData = {
      id: 0,
      name: name,
      description: description,
      financialYearId: selectedFinYear?.id,
      startDate: fieldsValue["date-picker"].format("YYYY-MM-DD"),
      endDate: fieldsValue["date-picker1"].format("YYYY-MM-DD"),
      nysContact: {
        id: 0,
        name: contactName,
        surname: surname,
        title_id: title_id,
        email: email,
        contactNumbers: contactNumbers,
      },
    };
    const entity = "NYS Programme";
    // const hide = message.loading("Submitting in progress, please wait...", 0);

    try {
      const response = await nysProgrammeService.createNYSProgramme(
        nysProgrammeData
      );

      if (response && (response.status === 201 || response.status === 200)) {
        props.onShow(false);
        form.resetFields();
        // hide();

        props.setHasUpdated(true);
        msg = util.parseMessage(Messages.ADD_SUCCESS, entity);

        openNotification("Create NYS Programme", msg, Notify.SUCCESS);
      }
      // else if (response && (response.status === 204)) {

      // }
      // else {
      //   // msg = util.parseMessage(Messages.ADD_FAILURE, entity);
      //   // openNotification("Create NYS Programme", msg, Notify.ERROR);
      // }
    } catch (error) {
      msg = util.parseMessage(Messages.ADD_FAILURE, entity);
      openNotification("Create NYS Programme", msg, Notify.ERROR);
      recordError(error);
    }
  };

  return (
    <>
      <Modal
        forceRender
        title="Add New NYS Programme Details"
        ke="modal-main"
        open={props.visible}
        closable={false}
        keyboard={false}
        maskClosable={false}
        width={900}
        footer={[
          <div key="modal-footer-buttons" className="modal-footer-buttons">
            <Button
              key="submit-button"
              type="primary"
              htmlType="submit"
              onSubmit={createProgramme}
              form={formName}
              disabled={disableForm}
            >
              Save
            </Button>
            <Popconfirm
              key="pop-confirm"
              title="Are you sure you want to cancel...you will lose all info entered?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => Confirm()}
              onCancel={handleCancel}
              disabled={disabled}
            >
              <Button
                onMouseUp={() => handleCancel()}
                style={{ marginLeft: 10 }}
                key="nys-programme-button"
              >
                Cancel
              </Button>
            </Popconfirm>
          </div>,
        ]}
      >
        <Form
          labelCol={{
            span: 4,
          }}
          wrapperCol={{
            span: 18,
          }}
          form={form}
          name={formName}
          onFinish={createProgramme}
        >
          <h4 key="nys-programme-main">
            <b>NYS Programme</b>
          </h4>
          <Alert
            key="nys-programme-alert"
            message="Things to note: "
            description={
              <>
                <b>
                  1. Only one programme can be created within the current, past
                  or upcoming financial year
                </b>{" "}
                <br />
                <b>
                  2. If financial year is NOT available from the list, add from{" "}
                  <Link key={1} to="/finyear">
                    <Tag color="blue">Manage Financial Year</Tag>
                  </Link>
                  page
                </b>{" "}
                <br />
                {disableForm && (
                  <b>
                    3. Form will be disabled if the programme already exists for
                    the selected financial year{" "}
                    <Link key={"form-fin-year"} to="/nysprogramme">
                      <Tag key="nys-programme-tag" color="blue">
                        {selectedFinYear.shortValue}
                      </Tag>
                    </Link>
                  </b>
                )}
              </>
            }
            type="info"
            showIcon
          />
          <br />
          <Card key="nys-programme-card">
            <Form.Item
              name="financialYear"
              label="Financial Year"
              rules={[
                {
                  required: true,
                  message: "Financial year is required",
                },
              ]}
            >
              <Select onChange={onChange}>
                {finYears.map((type) => (
                  <Option key={type.value}>{type.text}</Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="name"
              label="Name"
              rules={[
                {
                  required: true,
                  message: "Please provide NYS programme name",
                },
              ]}
            >
              <Input disabled={disableForm} />
            </Form.Item>
            <Form.Item
              name="description"
              label="Description"
              rules={[
                {
                  required: true,
                  message: "Please provide NYS programme description",
                },
              ]}
            >
              <Input disabled={disableForm} />
            </Form.Item>

            <Form.Item
              name="date-picker"
              label="Opening Date"
              placeholder="Select opening date"
              {...config}
              rules={[
                {
                  required: true,
                  message: "Please select programme opening date",
                },
                {
                  validator: async (_, startDate) => {
                    const selectedFinYear =
                      form.getFieldValue("financialYear")?.shortValue;
                    

                    const sepIndex = selectedFinYear.indexOf("/");
                    const fullPrevYear = `${selectedFinYear
                      .toString()
                      .substr(0, sepIndex)}`;
                    const fullNextYear = `${
                      parseInt(selectedFinYear.toString().substr(0, sepIndex)) +
                      1
                    }`;

                    if (startDate != null) {
                      var startDate1 = form
                        .getFieldValue("date-picker")
                        ?.format("YYYY-MM-DD");

                      if (startDate1 != null) {
                        // if (startDate1 < activeFinYear.startDate) {

                        //     return Promise.reject(
                        //         "Start date must not be before " + activeFinYear.startDate
                        //         );
                        //     }

                        if (
                          dayjs(startDate1).format("YYYY") < fullPrevYear ||
                          dayjs(startDate1).format("YYYY") > fullNextYear
                        ) {
                          return Promise.reject(
                            "Opening date cannot be before " +
                              fullPrevYear +
                              " or after " +
                              fullNextYear
                          );
                        }

                        var endDate = form
                          .getFieldValue("date-picker1")
                          ?.format("YYYY-MM-DD");

                        if (endDate === undefined) return;

                        if (startDate1 > endDate) {
                          return Promise.reject(
                            "Opening date must not be after " + endDate
                          );
                        }
                      }
                    }
                  },
                },
              ]}
            >
              <DatePicker disabled={disableForm} />
            </Form.Item>
            <Form.Item
              name="date-picker1"
              label="Closing Date"
              placeholder="Select closing date"
              {...config1}
              rules={[
                {
                  required: true,
                  message: "Please select programme closing date",
                },
                {
                  validator: async (_, endDate) => {
                    const selectedFinYear =
                      form.getFieldValue("financialYear")?.shortValue;

                    const sepIndex = selectedFinYear.indexOf("/");
                    const fullPrevYear = `${selectedFinYear
                      .toString()
                      .substr(0, sepIndex)}`;
                    const fullNextYear = `${
                      parseInt(selectedFinYear.toString().substr(0, sepIndex)) +
                      1
                    }`;

                    if (endDate != null) {
                      var endDate1 = form
                        .getFieldValue("date-picker1")
                        ?.format("YYYY-MM-DD");
                      var startDate = form
                        .getFieldValue("date-picker")
                        ?.format("YYYY-MM-DD");

                      if (endDate1 != null) {
                        if (endDate1 < startDate) {
                          return Promise.reject(
                            "Closing date must not be before " + startDate
                          );
                        }

                        if (
                          dayjs(endDate1).format("YYYY") < fullPrevYear ||
                          dayjs(endDate1).format("YYYY") > fullNextYear
                        ) {
                          return Promise.reject(
                            "Closing date cannot be before " +
                              fullPrevYear +
                              " or after " +
                              fullNextYear
                          );
                        }

                        // if (endDate1 > activeFinYear.endDate) {

                        //     return Promise.reject(
                        //         "End date must not be after " + activeFinYear.endDate
                        //     );
                        // }
                      }
                    }
                  },
                },
              ]}
            >
              <DatePicker disabled={disableForm} />
            </Form.Item>
          </Card>
          <h4 key="nys-programme-contact">
            <b>Contact Person</b>
          </h4>
          <Card key="nys-programme-contact-detail">
            <Form.Item
              name="contactName"
              label="Name"
              rules={[
                {
                  required: true,
                  message: "Please provide a valid name",
                },
              ]}
            >
              <Input disabled={disableForm} />
            </Form.Item>
            <Form.Item
              name="surname"
              label="Surname"
              rules={[
                {
                  required: true,
                  message: "Please select a valid surname",
                },
              ]}
            >
              <Input disabled={disableForm} />
            </Form.Item>
            <Form.Item
              name="title_id"
              label="Title"
              rules={[
                {
                  required: true,
                  message: "Please select a title",
                },
              ]}
            >
              <Select
                allowClear
                placeholder="Please select"
                disabled={disableForm}
              >
                {titles.map((title) => {
                  return (
                    <Option key={title.key} value={title.key}>
                      {title.value}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              name="email"
              label="Email Address"
              rules={[
                {
                  type: "email",
                  message: "The input is not valid E-mail",
                },
                {
                  required: true,
                  message: "Please provide valid email",
                },
              ]}
            >
              <Input disabled={disableForm} />
            </Form.Item>
            {/* <Row>
                            <Col span={4}>
                                
                            </Col>
                            <Col> */}
            <DynamicField key="dynamic" disabled={disableForm} />
            {/* </Col>
                        </Row> */}
          </Card>
        </Form>
      </Modal>
    </>
  );
}
